import { LANGUAGE_ENUMS } from '../../../constants/staticPageConstants';
import { TDropdownList } from '../DynamicHeader/Dropdown/DropdownComponent';
import { DesktopNavBar } from './DesktopHeader';
import { MobileNavBar } from './MobileHeader';

const FrCommonNavbar = ({
  language = LANGUAGE_ENUMS.English,
  LangSwitchLink,
  domain,
}: {
  language?: LANGUAGE_ENUMS;
  LangSwitchLink?: TDropdownList;
  domain: number;
}): JSX.Element => {
  return (
    <>
      <div className={`sm:hidden`} data-testid="fr-navbar">
        <DesktopNavBar
          domain={domain}
          language={language}
          LangSwitchLink={LangSwitchLink}
        />
      </div>
      <div className={`hidden sm:block`}>
        <MobileNavBar
          domain={domain}
          language={language}
          LangSwitchLink={LangSwitchLink}
        />
      </div>
    </>
  );
};

export { FrCommonNavbar };
